/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CounselorDutyType = {
    Aw12: 'Aw12',
    Aw3: 'Aw3',
    Court: 'Court'
} as const;
export type CounselorDutyType = typeof CounselorDutyType[keyof typeof CounselorDutyType];


export function instanceOfCounselorDutyType(value: any): boolean {
    for (const key in CounselorDutyType) {
        if (Object.prototype.hasOwnProperty.call(CounselorDutyType, key)) {
            if (CounselorDutyType[key as keyof typeof CounselorDutyType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CounselorDutyTypeFromJSON(json: any): CounselorDutyType {
    return CounselorDutyTypeFromJSONTyped(json, false);
}

export function CounselorDutyTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CounselorDutyType {
    return json as CounselorDutyType;
}

export function CounselorDutyTypeToJSON(value?: CounselorDutyType | null): any {
    return value as any;
}

export function CounselorDutyTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CounselorDutyType {
    return value as CounselorDutyType;
}

